import axios from 'axios'

/**
 * @desc Fetches all price drops for specified supplier
 * @desc fetchPromotionRulesForSupplier in BFF
 * @param {String} supplierId
 * @param {Object} options
 */
export const fetchPriceDrops = (supplierId, options = {}) =>
  axios
    .get(`/authenticated/supplier/${supplierId}/price-drop-rules`, {
      params: options
    })
    .then((res) => res.data)

/**
 * @desc Creates new price drop for product
 * @desc addPromotionRule in BFF
 * @param {String} supplierId
 * @param {Object} promotion
 */
export const createPriceDrop = (supplierId, promotion) =>
  axios
    .post(`/authenticated/supplier/${supplierId}/price-drop-rules`, promotion)
    .then((res) => res.data)

/**
 * @desc Updates promotion
 * @desc editPromotionRule in BFF
 * @param {String} supplierId
 * @param {String} promotionId
 * @param {Object} promotion
 */
export const updatePriceDrop = (supplierId, promotionId, promotion) =>
  axios
    .put(
      `/authenticated/supplier/${supplierId}/price-drop-rules/${promotionId}`,
      promotion
    )
    .then((res) => res.data)

/**
 * @desc Deletes promotion
 * @desc deletePromotionRule in BFF
 * @param {String} supplierId
 * @param {String} promotionId
 */
export const deletePriceDrop = (supplierId, promotionId) =>
  axios
    .delete(
      `/authenticated/supplier/${supplierId}/price-drop-rules/${promotionId}`
    )
    .then((res) => res.data)
